import * as Yup from "yup";
import { useFormik } from "formik";
import { Box, Grid } from "@mui/material";
import FormikControl from "../../common/FormikControl";
import { LoadingButton } from "@mui/lab";
import BsModal from "../../common/BaseModal";
import { useDispatch } from "react-redux";
import { modeOfRejectionLSM } from "../../../slices/logisticSlice";
import { useNavigate } from "react-router";
import moment from "moment";

const initialValues = {
    reset_apheresis: "",
    apheresis_date: "",
};
const validationSchema = Yup.object().shape({
    reset_apheresis: Yup.string().required("Reason is required"),
    apheresis_date: Yup.string()
        .when('reset_apheresis', {
            is: (reset_apheresis) => reset_apheresis == '2',
            then: Yup.string()
                .required("Apheresis date is required")
                .max(255, "Maximum of 255 characters"),
            otherwise: Yup.string().notRequired()
        })
});

const optionReason = [
    { value: 1, label: "Schedule Apheresis Date Range" },
    { value: 2, label: "Request Apheresis Date" }
]


const ResetLSMApheresis = ({ open, setOpen, taskDetails }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const handleSubmit = async (values) => {

        try {
            const data = {
                id: taskDetails?.subject?.id,
                data: { ...values, apheresis_date: moment(values?.apheresis_date, "DD/MM/YYYY").format("YYYY-MM-DD") }
            }
            await dispatch(modeOfRejectionLSM(data))
            setOpen(false)
            if (taskDetails?.redirect_uri) {
                navigate(taskDetails.redirect_uri);
            }
        } catch (err) {
            console.error(err);
        }
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: handleSubmit,
    });

    const formOptions = [
        {
            label: "Pick an Option to Continue",
            type: "radio",
            name: "reset_apheresis",
            options: optionReason,
            required: true,
        },
        ...(formik.values.reset_apheresis == 2 ? [{
            type: "date",
            name: "apheresis_date",
            required: true,
            min: new Date(),
            placeholder: "Select date",
        }] : [])
    ];


    return (

        <BsModal
            fullWidth={true}
            open={open}
            onClose={() => setOpen(false)}
            title={"Restart Apheresis Request"}
        >
            <Box>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2} className="mb-3">
                        {formOptions.map((props, key) => (
                            <Grid key={key} item xs={12}>
                                <FormikControl formik={formik} {...props} />
                            </Grid>
                        ))}
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <LoadingButton fullWidth type="submit" variant="contained">
                                Submit
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </BsModal>
    );
};

export default ResetLSMApheresis;
